import React, { useEffect, useState } from 'react';
import { Section } from './Section';
import { motion, AnimatePresence } from 'framer-motion';
export function Brands() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const allBrands = [{
    name: 'TEDx',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/TED_Logo_2.svg/512px-TED_Logo_2.svg.png'
  }, {
    name: 'TEDxWarri',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/m9qWhHSu1v482amxqbWXma/tedxwarri.jpg'
  }, {
    name: 'YALI Network',
    logo: 'https://yali.state.gov/wp-content/uploads/sites/4/2016/07/YALI_LOGO_with_text.png'
  }, {
    name: 'YALI Network Edo',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tv631tBafuSNuEBBA9hM6B/yali_logo.png'
  }, {
    name: 'GIZ',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/28nwky3gc5wUaK6qEFdhdK/GIZ.png'
  }, {
    name: 'GOPA',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rG3mcsx8WAx3VXBpcDQaGA/GOPA.png'
  }, {
    name: 'PanAfrican Capital Foundation',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mtgTv26EoWm2UjtNfmT7sV/Panafrican.jpg'
  }, {
    name: 'University of Benin',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4iqAqVizcbvMK65Diu9jRK/Uniben_logo.png'
  }, {
    name: 'SkillzHQ',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pT23cACXux2UnYjrDbuBny/skillzhq.png'
  }, {
    name: 'Edo State Government',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oHmDX12Lf8FXfhqJTZearW/Edo_State_Government.jpg'
  }, {
    name: 'Delta State Government',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/x2j6YMn4Likw1wiPx5BYYj/delta.png'
  }, {
    name: 'Oredo Government Council',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qFGUHjPdNdVc79dAz4U6Mg/Oredo.jpg'
  }, {
    name: 'The World Bank',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ffDnRaLN945KX8sTAkfFHt/World_Bank.png'
  }, {
    name: 'SEYP',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sn7v5qpt7XHbwwx3FPHQjT/SEYP.jpg'
  }, {
    name: 'World Merit',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/62dRkqLfDdFN2zjiuoAFQN/World_merit.png'
  }, {
    name: 'AFLDC',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cwZ2NuBQyJh3B9gPPTuy1U/AFLDC.png'
  }, {
    name: 'Gotni Leadership Centre',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rEXgEcHFwJJSxzL56pCbMY/Gotni.jpg'
  }, {
    name: 'NIMSA',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6pyTyGNFUhpYY4bbSKmiRJ/Nimsa.jpg'
  }];
  // Group brands into slides of 5
  const slidesCount = Math.ceil(allBrands.length / 5);
  const slides = Array.from({
    length: slidesCount
  }, (_, i) => allBrands.slice(i * 5, (i + 1) * 5));
  // Auto-advance the carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slidesCount);
    }, 5000);
    return () => clearInterval(interval);
  }, [slidesCount]);
  return <Section id="brands" title="Brands I've Worked With" data-id="element-21">
      <div className="text-center mb-6" data-id="element-22">
        <p className="text-sm text-gray-500" data-id="element-23">Indirectly or Directly</p>
      </div>
      <div className="max-w-5xl mx-auto relative overflow-hidden" data-id="element-24">
        <div className="h-52 relative" data-id="element-25">
          <AnimatePresence mode="wait" data-id="element-26">
            <motion.div key={currentSlide} className="absolute inset-0 flex justify-center" initial={{
            opacity: 0,
            x: 100
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -100
          }} transition={{
            duration: 0.5
          }} data-id="element-27">
              <div className="grid grid-cols-5 gap-4 w-full" data-id="element-28">
                {slides[currentSlide].map(brand => <div key={brand.name} className="flex items-center justify-center p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-29">
                    <img src={brand.logo} alt={brand.name} className="h-32 w-32 object-contain filter grayscale opacity-80 hover:opacity-100 transition-opacity duration-300" data-id="element-30" />
                  </div>)}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
        {/* Carousel Indicators */}
        <div className="flex justify-center mt-6 gap-2" data-id="element-31">
          {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-colors ${index === currentSlide ? 'bg-gray-800' : 'bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-32" />)}
        </div>
      </div>
    </Section>;
}